(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info-components/assets/javascripts/general-match-info.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info-components/assets/javascripts/general-match-info.js');
"use strict";


const {
  useSelector
} = ReactRedux;
const {
  selectSportEvent,
  selectLeague,
  selectSportEventIsRejected,
  selectSportEventShouldShowSkeleton
} = svs.components.sportinfo.matchInfoRedux.selectors;
const {
  StatisticSection
} = svs.components.sportinfo.matchInfoComponents;
const GeneralMatchInfoList = _ref => {
  let {
    children
  } = _ref;
  return React.createElement("ol", {
    className: "general-match-info-table",
    role: "table"
  }, children);
};
const GeneralMatchInfoListItem = _ref2 => {
  let {
    label,
    content,
    ariaLabel
  } = _ref2;
  const hasContent = Boolean(content);
  return React.createElement("li", {
    "aria-label": ariaLabel,
    className: "general-match-info-table-row",
    role: "row"
  }, React.createElement("span", {
    className: "general-match-info-table-row-label",
    role: hasContent ? 'rowheader' : 'cell'
  }, label), hasContent && React.createElement("span", {
    className: "general-match-info-table-row-content",
    role: "cell"
  }, content));
};
const GeneralMatchInfo = _ref3 => {
  var _league$country, _league$country2;
  let {
    matchId
  } = _ref3;
  const shouldShowSkeleton = useSelector(state => selectSportEventShouldShowSkeleton(state, matchId));
  const matchInfoIsRejected = useSelector(state => selectSportEventIsRejected(state, matchId));
  const sportEvent = useSelector(state => selectSportEvent(state, matchId));
  const league = useSelector(state => selectLeague(state, sportEvent === null || sportEvent === void 0 ? void 0 : sportEvent.leagueId));
  if (shouldShowSkeleton) {
    return 'laddar...';
  } else if (matchInfoIsRejected) {
    return null;
  }
  const hasLeague = Boolean(league);
  const startDate = dateFns.format(new Date(sportEvent.matchStart), 'EEEE d MMMM yyyy', {
    locale: dateFns.locales.sv
  });
  return React.createElement(StatisticSection, {
    heading: "Allm\xE4n information"
  }, React.createElement(GeneralMatchInfoList, null, React.createElement(GeneralMatchInfoListItem, {
    ariaLabel: "Datum: ".concat(startDate[0].toUpperCase() + startDate.slice(1)),
    content: startDate[0].toUpperCase() + startDate.slice(1),
    label: "Datum"
  }), React.createElement(GeneralMatchInfoListItem, {
    ariaLabel: "Tid: ".concat(dateFns.format(new Date(sportEvent.matchStart), 'HH:mm', {
      locale: dateFns.locales.sv
    })),
    content: dateFns.format(new Date(sportEvent.matchStart), 'HH:mm', {
      locale: dateFns.locales.sv
    }),
    label: "Tid"
  }), hasLeague && React.createElement(GeneralMatchInfoListItem, {
    ariaLabel: league.name + ((_league$country = league.country) !== null && _league$country !== void 0 && _league$country.name ? ", ".concat(league.country.name) : ''),
    label: league.name + ((_league$country2 = league.country) !== null && _league$country2 !== void 0 && _league$country2.name ? ", ".concat(league.country.name) : '')
  }), React.createElement(GeneralMatchInfoListItem, {
    ariaLabel: "Plats: ".concat(sportEvent.arena),
    label: sportEvent.arena
  })));
};
setGlobal('svs.components.sportinfo.matchInfoComponents.GeneralMatchInfo', GeneralMatchInfo);

 })(window);